import type { Country } from 'react-phone-number-input';

import { SvgIcon, SvgIconProps } from '@mui/material';
import flags from 'react-phone-number-input/flags';

type TFlagProps = SvgIconProps & {
  country: Country;
};

export const Flag = ({ country, ...props }: TFlagProps) => {
  const { [country]: flag } = flags;
  const { viewBox, children } = flag?.({ title: '' }).props || {};

  return (
    <SvgIcon viewBox={viewBox} {...props}>
      {children}
    </SvgIcon>
  );
};
